
import { AssetApprovalDetailsRequestModel } from './assetapprovalDetailsRequestModel';

export class AssetPurchaseOrderApprovalCycleRequestModel{
    code : string;
    sitesId : number[];
    isEnable : boolean;
    vendorsId : number[];
    AssetApprovalDetails : AssetApprovalDetailsRequestModel[];
}
